import axios from 'axios';
import { BASE_URL } from './booking';

export const getPickerDetails = (id: string) => axios.get(`${BASE_URL}/admin/getPickerDetails?pickerID=${id}`);
export const getCustomerById = (id?: string) => axios.get(`${BASE_URL}/admin/userDetails?userID=${id}`);
